import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { Preferences } from '../../profile/objects/preferences';
import { DEFAULT_COLUMN, SITE_MODULE } from '../constant/siteConstant';
import { Column } from '../objects/column';

export const setSitePreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: SITE_MODULE,
    default_columns: DEFAULT_COLUMN,
    default_order_by: '-created_date',
    default_order: 'asc',
});
